import { render, staticRenderFns } from "./ProgramBranding.vue?vue&type=template&id=29cb2773&scoped=true&"
import script from "./ProgramBranding.vue?vue&type=script&lang=js&"
export * from "./ProgramBranding.vue?vue&type=script&lang=js&"
import style0 from "./ProgramBranding.vue?vue&type=style&index=0&id=29cb2773&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29cb2773",
  null
  
)

component.options.__file = "ProgramBranding.vue"
export default component.exports